import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { Badge } from '@/components/ui/badge';
import { MessageCircle, Clock, AlertCircle } from 'lucide-react';

export function BotMessagesSettings() {
  const messages = [
    {
      type: 'Bienvenida',
      icon: <MessageCircle className="w-4 h-4 text-green-600" />,
      content: '¡Hola! 👋 Soy el asistente virtual de [Tu Empresa]. ¿En qué puedo ayudarte hoy?',
      status: 'Activo'
    },
    {
      type: 'Fuera de horario',
      icon: <Clock className="w-4 h-4 text-blue-600" />,
      content: 'Gracias por escribirnos. Nuestro horario de atención es de Lunes a Sábado de 8AM a 8PM. Te responderemos cuando volvamos a estar disponibles.',
      status: 'Activo'
    },
    {
      type: 'No entiendo',
      icon: <AlertCircle className="w-4 h-4 text-orange-600" />,
      content: 'Disculpa, no logré entender tu consulta. ¿Podrías reformularla? Si necesitas ayuda inmediata, puedes contactar a nuestro equipo humano.',
      status: 'Activo'
    }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Mensajes del Bot</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {messages.map((message, index) => (
            <div key={index} className="space-y-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  {message.icon}
                  <span className="font-medium text-sm">{message.type}</span>
                </div>
                <Badge variant="outline">{message.status}</Badge>
              </div>
              
              <Textarea 
                value={message.content}
                disabled
                className="min-h-[80px]"
                placeholder="Mensaje del bot..."
              />
            </div>
          ))}
        </div>

        <div className="mt-6 p-4 bg-gray-50 rounded-lg">
          <p className="text-sm text-muted-foreground">
            <strong>Información:</strong> Los mensajes del bot están optimizados para tu negocio. 
            Si necesitas cambios, contacta a nuestro equipo de soporte.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}